<template>
  <transition name="fade">
    <div class="bb-table-body-checkbox">
      <checkbox :name="name"
                @checkboxChange="checkboxChange"
                :disabled="disable"
                :value="value"/>
    </div>
  </transition>
</template>

<script>
import Checkbox from '@/components/Main/Inputs/checkbox'
export default {
  name: 'IncludeInGeneralExpenses',
  components: {Checkbox},
  props: ['name', 'value', 'disable'],
  methods: {
    checkboxChange (data, item) {
      item.excludeExpenses = !data
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../../../../sass/variables";
  @import "../../../../../../../../sass/mixins";
</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/TableSoA/Columns/IncludeInGeneralExpenses.vue